import { useState, useEffect, useReducer } from "react"
import MapView from "./Mapping/MapView"
import Header from "./Header"
import SideControl from "./SideControl"
import ViewFacility from "./ViewFacility"
import MainStatsCard from "./StatsCardComponents/MainStatsCard"
import EditCup from "./EditCup"
import EditFacility from "./EditFacility"
import axios from "axios"
import import_data from "../utils/load"
import { useParams } from "react-router-dom"
import { initialMapDataState, mapDataReducer } from "../reducers/mapData"
import { initialUiState, uiReducer } from "../reducers/ui"
import HandleFail from "../utils/error_handler"
import initial_visualisation_settings from "../configs/initial_visualisation_settings.json"

function App() {
  const [map_data, dispatch_map_data] = useReducer(
    mapDataReducer,
    initialMapDataState,
  )
  const [ui, dispatch_ui] = useReducer(uiReducer, initialUiState)
  const [map_ref, set_map_ref] = useState(null)
  const [change_requests, set_change_requests] = useState([])
  const [visualisation_settings, set_visualisation_settings] = useState(
    initial_visualisation_settings,
  )

  const { session_id } = useParams()

  useEffect(() => {
    if (!map_ref) {
      return
    }
    const load_session = async (id) => {
      dispatch_ui({ type: "START_LOADING" })
      await HandleFail(async () => {
        const { data } = await axios.get(`/api/session/${id}`)
        import_data({
          data,
          dispatch_map_data,
          map_ref,
          set_change_requests,
        })
      })
      dispatch_ui({ type: "STOP_LOADING" })
    }
    load_session(session_id)
  }, [session_id, map_ref])

  return (
    <>
      <Header
        collapsible={true}
        dispatch_ui={dispatch_ui}
        loading={ui.loading}
        open={ui.drawer_open}
      />

      <SideControl
        open={ui.drawer_open}
        map_data={map_data}
        dispatch_map_data={dispatch_map_data}
        dispatch_ui={dispatch_ui}
        set_visualisation_settings={set_visualisation_settings}
        visualisation_settings={visualisation_settings}
        map_ref={map_ref}
        change_requests={change_requests}
        set_change_requests={set_change_requests}
      />

      <ViewFacility
        dispatch_ui={dispatch_ui}
        current_view_facility_id={ui.view.facility}
        fac_geo_json={map_data.fac_geo_json}
      />

      <MapView
        map_data={map_data}
        dispatch_ui={dispatch_ui}
        dispatch_map_data={dispatch_map_data}
        map_ref={map_ref}
        set_map_ref={set_map_ref}
        visualisation_settings={visualisation_settings}
        current_view_cup_id={ui.view.cup}
        current_view_district_id={ui.view.district}
        set_change_requests={set_change_requests}
      />

      <EditCup
        current_edit_cup={ui.edit.cup}
        fac_geo_json={map_data.fac_geo_json}
        dispatch_map_data={dispatch_map_data}
        dispatch_ui={dispatch_ui}
      />

      <EditFacility
        current_edit_facility={ui.edit.facility}
        dispatch_map_data={dispatch_map_data}
        dispatch_ui={dispatch_ui}
      />

      <MainStatsCard
        mode={"cups"}
        current_id={ui.view.cup}
        map_data={map_data}
        dispatch_ui={dispatch_ui}
      />

      <MainStatsCard
        mode={"districts"}
        current_id={ui.view.district}
        map_data={map_data}
        dispatch_ui={dispatch_ui}
      />
    </>
  )
}

export default App
